import { render, staticRenderFns } from "./SatinalmaIadearizaDetay.vue?vue&type=template&id=69d55b14&"
import script from "./SatinalmaIadearizaDetay.vue?vue&type=script&lang=js&"
export * from "./SatinalmaIadearizaDetay.vue?vue&type=script&lang=js&"
import style0 from "./SatinalmaIadearizaDetay.vue?vue&type=style&index=0&id=69d55b14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports